import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyDUcT3_eWCLDo84ufizzE5AqtO8c2Ch8fs",
  authDomain: "weve-b5a88.firebaseapp.com",
  projectId: "weve-b5a88",
  storageBucket: "weve-b5a88.firebasestorage.app",
  messagingSenderId: "828113251296",
  appId: "1:828113251296:web:b709da2e92e419e034d985",
  measurementId: "G-Y2ZLMRCTQ8"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics (only in browser)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Initialize Firestore
const db = getFirestore(app)

// Initialize Auth
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

export { app, analytics, db, auth, googleProvider }
